import React from 'react';
import { peptideData } from './peptideData';
export const PeptideExplorer = ({
  globalSearchQuery = ''
}) => {
  // Filter peptides based on global search if provided, otherwise show all
  const filteredPeptides = peptideData.filter(peptide => {
    if (globalSearchQuery) {
      return peptide.name.toLowerCase().includes(globalSearchQuery.toLowerCase()) || peptide.description && peptide.description.toLowerCase().includes(globalSearchQuery.toLowerCase()) || peptide.originalName && peptide.originalName.toLowerCase().includes(globalSearchQuery.toLowerCase()) || peptide.link.toLowerCase().includes(globalSearchQuery.toLowerCase());
    }
    return true;
  });
  return <div className="w-full" data-id="element-246">
      {/* Results count */}
      <div className="text-center mb-6" data-id="element-247">
        <p className="font-['Roboto',sans-serif] text-lg text-gray-600" data-id="element-248">
          {filteredPeptides.length} peptides found
          {globalSearchQuery && ` for "${globalSearchQuery}"`}
        </p>
      </div>
      {/* Peptide grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-249">
        {filteredPeptides.map((peptide, index) => <div key={peptide.id} className={`bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow ${index % 2 === 0 ? 'border border-[#2290F7]/30' : 'border border-[#E91E63]/30'}`} data-id="element-250">
            <h3 className="font-['Roboto',sans-serif] font-bold text-xl mb-2" data-id="element-251">
              {peptide.name}
            </h3>
            {peptide.originalName && <p className="font-['Roboto',sans-serif] text-sm text-gray-600 mb-2" data-id="element-252">
                Upgraded from {peptide.originalName}
              </p>}
            <a href={peptide.link} target="_blank" rel="noopener noreferrer nofollow" className="font-['Roboto',sans-serif] text-[#2290F7] font-bold hover:text-[#1a74d4] transition-colors break-words" data-id="element-253">
              {peptide.link.replace('https://', '')}
            </a>
          </div>)}
      </div>
      {/* Show message if no results */}
      {filteredPeptides.length === 0 && <div className="text-center py-10" data-id="element-254">
          <p className="font-['Roboto'] text-xl text-gray-600" data-id="element-255">
            No peptides found.
          </p>
        </div>}
    </div>;
};